export default __webpack_public_path__ + "static/media/controlShareIOS24.be35cd2d.svg";